import {
	mdiAccountClockOutline,
	mdiAccountSearchOutline,
	mdiCashMultiple,
	mdiChartTimeline,
	mdiDomain,
	mdiEarth,
	mdiHandshake,
	mdiHome,
	mdiLayersTripleOutline,
	mdiPresentationPlay,
	mdiStar,
	mdiTune,
} from '@mdi/js'

export default [
	{
		icon: mdiHome,
		title: 'menu.ventures.dashboard',
		to: 'ventures-dashboard',
	},
	{
		title: 'menu.ventures.references',
		icon: mdiTune,
		children: [
			{
				title: 'menu.ventures.categories',
				to: 'ventures-categories-list',
			},
			{
				title: 'menu.ventures.investorTypes',
				to: 'ventures-investor-types-list',
			},
			{
				title: 'menu.ventures.pitchMediaTypes',
				to: 'ventures-pitch-media-types-list',
			},
			{
				title: 'menu.ventures.scoreAxes',
				to: 'ventures-score-axes-list',
			},
			{
				title: 'menu.ventures.stages',
				to: 'ventures-stages-list',
			},
			{
				title: 'menu.ventures.regions',
				to: 'ventures-regions-list',
			},
		],
	},
	{
		title: 'menu.ventures.projects',
		icon: mdiLayersTripleOutline,
		to: 'ventures-projects-list',
	},
	{
		title: 'menu.ventures.studioProspects',
		icon: mdiAccountSearchOutline,
		to: 'ventures-studio-prospects-list',
	},
	{
		title: 'menu.ventures.investors',
		icon: mdiDomain,
		to: 'ventures-investors-list',
	},
	{
		title: 'menu.ventures.investorProspects',
		icon: mdiAccountSearchOutline,
		to: 'ventures-investor-prospects-list',
	},
	{
		title: 'menu.ventures.publishers',
		icon: mdiStar,
		to: 'ventures-publishers-list',
	},
	{
		title: 'menu.ventures.investments',
		icon: mdiCashMultiple,
		to: 'ventures-investments-list',
	},
	{ subheader: 'menu.ventures.operational' },
	{
		title: 'menu.ventures.waitlist',
		icon: mdiAccountClockOutline,
		to: 'ventures-waitlist-list',
	},
	{
		title: 'menu.ventures.pitches',
		icon: mdiPresentationPlay,
		to: 'ventures-pitches-list',
	},
	{
		title: 'menu.ventures.connections',
		icon: mdiHandshake,
		to: 'ventures-connections-list',
	},
	{
		title: 'menu.ventures.scoreEngine',
		icon: mdiChartTimeline,
		to: 'ventures-score-engine-list',
	},
]
